
<div #mapContainer class="mapbox-map" [class.mapbox-provider]="_mapProvider === 'mapbox'"></div>
